(() => {
  const initReviews = (section) => {
    if (!section || section.dataset.pepexReviewsReady === 'true') return;

    const track = section.querySelector('[data-pepex-review-track]');
    const previousButton = section.querySelector('[data-pepex-review-prev]');
    const nextButton = section.querySelector('[data-pepex-review-next]');

    if (!track || !previousButton || !nextButton) return;

    section.dataset.pepexReviewsReady = 'true';

    const cardStep = () => {
      const firstCard = track.querySelector('.pepex-review');
      if (!firstCard) return track.clientWidth;

      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0');
      return firstCard.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previousButton.disabled = track.scrollLeft <= 2;
      nextButton.disabled = track.scrollLeft >= maxScroll - 2;
    };

    previousButton.addEventListener('click', () => {
      track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      track.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  };

  const initAllReviews = (root = document) => {
    root.querySelectorAll('.pepex-reviews').forEach(initReviews);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllReviews());
  } else {
    initAllReviews();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllReviews(event.target);
  });
})();
